import React, { useRef, useEffect, useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import QuickSearchResult from './QuickSearchResult';
import { translate } from '../Services/translation';
import { query, setSearchQuery, toggleShowFullForm, closeSearchResults, handleKeyDown, handleClickSearch } from '../Actions/QuickSearch.action';
import { debounce } from 'lodash-es';
import usePrevious from '@react-hook/previous';

const debouncedQuery = debounce((dispatch, text) => dispatch(query(text)), 200);

const QuickSearch = () => {
    const { query, result, showResult, showFullForm, selectedItem } = useSelector((state) => state.quickSearch);
    const [lastClickedNode, setLastClickedNode] = useState(null);
    const searchUrl = window.__litium.quickSearchUrl + (query.length > 0 ? `?q=${query}` : '');
    const searchContainer = useRef(null);
    const searchInput = useRef(null);
    const dispatch = useDispatch();
    const previousSelectedItem = usePrevious(selectedItem);

    const clickHandler = useCallback((event) => {
        setLastClickedNode(event.target);
        if(!event.target.closest('.quick-search-container')) {
            dispatch(closeSearchResults());
        }
    }, []);

    useEffect(() => {
        window.addEventListener('mousedown', clickHandler);
        return () => window.removeEventListener('mousedown', clickHandler);
    }, [clickHandler]);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('q')) {
            const query = urlParams.get('q');
            dispatch(setSearchQuery(query));
        }
    }, [dispatch]);

    useEffect(() => {
        if (selectedItem !== previousSelectedItem) {
            const el = document.querySelector('.quick-search-result__item--selected');
            el &&
                el.scrollIntoView({
                    behavior: 'smooth',
                    block: 'end',
                    inline: 'nearest',
                });
        }
    }, [selectedItem, previousSelectedItem]);

    return (
        <div className='quick-search-container'>
            <div className='quick-search' role='search' ref={searchContainer}>
                <label className='quick-search__input'>
                    <svg>
                        <use href='/ui/images/sprites/be-group.svg#Search'></use>
                    </svg>
                    <input className='quick-search__input' type='search' placeholder={translate('general.searchplaceholder')}
                        autoComplete='off' value={decodeURIComponent(query)}
                        onChange={(event) => {
                            const text = encodeURIComponent(event.target.value); dispatch(setSearchQuery(text)); debouncedQuery(dispatch, text);
                        }}
                        onKeyDown={(event) =>
                            dispatch(handleKeyDown(event, { searchUrl }))
                        }
                        ref={searchInput}
                        onBlur={() => {
                            if (searchContainer.current && !searchContainer.current.contains(lastClickedNode)) {
                                showFullForm && dispatch(toggleShowFullForm());
                            }
                        }}
                    />
                </label>
                <button className='quick-search__submit-button button' type='submit' onClick={(e) => { e.preventDefault(); dispatch(handleClickSearch({ searchUrl })); }}                >
                    <i className='quick-search__submit-icon'></i>
                    <span className='quick-search__submit-title'>
                        {translate('general.search')}
                    </span>
                </button>
            </div>
            {showResult && (
                <QuickSearchResult
                    result={result}
                    selectedItem={selectedItem}
                    searchUrl={searchUrl}
                />
            )}
        </div>
    );
};

export default QuickSearch;
